import {createStore} from "vuex";

export default createStore({
    state: {
        hideConfigButton: false,
        isPinned: true,
        showConfig: false,
        sidebarType: "bg-white",
        isRTL: false,
        mcolor: "",
        darkMode: false,
        isNavFixed: false,
        isAbsolute: false,
        showNavs: true,
        showSidenav: true,
        showNavbar: true,
        showFooter: true,
        showMain: true,
        layout: "default",

        clientsIsLoading: false,
        clientsTotalSteps: 2,
        clientShowModal: false,
        clientRequestIsLoading: false,

        clientCreateFullName: null,
        clientCreateBirthday: null,
        clientCreateLegalData: false,
        clientCreateFirstPhone: null,
        clientCreateSecondPhone: null,
        clientCreateAddress: null,
        clientCreateEmail: null,
        clientCreatePassport: null,
        clientCreatePassportScan: null,
        clientCreatePassportIssueDate: null,
        clientCreatePassportIssuingAuthorityId: null,
        clientCreateRegistrationAddress: null,
        clientCreateWorkInfo: null,

        clientCreateCompanyName: null,
        clientCreateAuthorizedPerson: null,
        clientCreateAuthorityBasis: null,
        clientCreateLegalAddress: null,
        clientCreateCompanyPhone: null,
        clientCreateTaxNumber: null,
        clientCreateBankAccount: null,
        clientCreateInvoiceDate: null,
        clientCreateBic: null,

        clientId: null,
        clientIsEditable: false,

        clientPersonalData: null,
        clientShowData: false,
        clientLoadData: false,
        personaDataId: null,

        clientLegalData: null,
        clientLegalShowData: false,
        clientLegalLoadData: false,
        legalDataId: null,

        currentClientName: null,

        isProductLoading: false,
        isBlackListLoading: false,
        isRepairLoading: false,

        productCreateName: null,
        productCreateEquipmentCost: null,
        productCreateRentCost: null,
        productCreateDescription: null,
        productCreateComplectation: null,
        productCreateSerialNumber: null,
        productCreateQty: null,
        productId: null,

        clientSearchText: null,
        clientSortType: null,

        productSearchText: null,
        productSortType: null,

        blackListSearchText: null,
        blackListSortType: null,

        clientListSize: 20,
        clientPaginationStart: 0,

        productListSize: 20,
        productPaginationStart: 0,

        blackListSize: 20,
        blackListPaginationStart: 0,

        repairListSize: 20,
        repairPaginationStart: 0,

        showOrderModal: false,

        orderDataIsLoading: false,

        createOrderStatus: 2,
        createOrderClient: null,
        createOrderProduct: null,
        createOderSingleProductPrice: null,
        createOrderProductCount: null,
        createOrderSelectedCount: null,
        createSingleOrderTotalPrice: 0,
        createOrderFrom: null,
        createOrderTo: null,
        createOrderDiscount: 0,
        createOrderDayDifference: 0,
        createOrderPromo: 0,
        createOrderItems: [],
        orderDeposit: 0,
        orderShipment: 0,
        orderAssembly: 0,
        orderInstallation: 0,
        orderPaidFor: 0,

        isOrderDataLoading: false,

        orderProductsModal: false,
        orderViewProductsIsLoading: false,
        orderProductsView: [],
        orderEditable: false,

        updateOrderId: null,
        orderListSize: 20,
        orderPaginationStart: 1,
        filterOrderByStatusId: 0,

        filterOrderByDate: null,
        filterOrderByDateStart: null,

        arendaOrderStart: null,
        arendaOrderEnd: null,

        searchOrderName: null,

        orderAddProductModal: false,
        countControllers: [],
        availableCountProducts: [],
        clientFilterStr: null,
        passportFilterAuthor: null,
        isDocLoading: false,

        passportCreateName: null,
        createPassportModal: false,
        passportAuthors: [],

        clientOrders: [],
        clientsOrdersModal: false,
        clientOrderStatisticItem: null,

        productAdditionalInfoModal: false,
        productAdditionalInfo: null,

        addProductSearchStr: "",

        productsInSales: false,

        clientNameInOrder: null,
        clientPhoneInOrder: null,

        createRepairProductId: null,
        createRepairReason: null,
        createRepairProductFilter: null,
        repairProducts: null,
        sezon: null,
    },
    mutations: {
        toggleConfigurator(state) {
            state.showConfig = !state.showConfig;
        },
        navbarMinimize(state) {
            const sidenav_show = document.querySelector(".g-sidenav-show");

            if (sidenav_show.classList.contains("g-sidenav-hidden")) {
                sidenav_show.classList.remove("g-sidenav-hidden");
                sidenav_show.classList.add("g-sidenav-pinned");
                state.isPinned = true;
            } else {
                sidenav_show.classList.add("g-sidenav-hidden");
                sidenav_show.classList.remove("g-sidenav-pinned");
                state.isPinned = false;
            }
        },
        sidebarType(state, payload) {
            state.sidebarType = payload;
        },
        navbarFixed(state) {
            if (state.isNavFixed === false) {
                state.isNavFixed = true;
            } else {
                state.isNavFixed = false;
            }
        },
        updateClientCreateFullName(state, payload) {
            state.clientCreateFullName = payload;
        },
        updateClientCreateLegalData(state, payload) {
            state.clientCreateLegalData = payload;
        },
        updateClientCreateFirstPhone(state, payload) {
            state.clientCreateFirstPhone = payload;
        },
        updateClientCreateAddress(state, payload) {
            state.clientCreateAddress = payload;
        },
        updateClientCreateEmail(state, payload) {
            state.clientCreateEmail = payload;
        },
        updateClientCreateSecondPhone(state, payload) {
            state.clientCreateSecondPhone = payload;
        },
        updateClientCreatePassport(state, payload) {
            state.clientCreatePassport = payload;
        },
        updateClientCreateRegistrationAddress(state, payload) {
            state.clientCreateRegistrationAddress = payload;
        },
        updateClientCreateWorkInfo(state, payload) {
            state.clientCreateWorkInfo = payload;
        },
        updateClientIsLoading(state, payload) {
            state.clientsIsLoading = payload;
        },
        updateClientTotalSteps(state, payload) {
            state.clientsTotalSteps = payload;
        },
        updateClientCreateCompanyName(state, payload) {
            state.clientCreateCompanyName = payload;
        },
        updateClientCreateAuthorizedPerson(state, payload) {
            state.clientCreateAuthorizedPerson = payload;
        },
        updateClientCreateAuthorityBasis(state, payload) {
            state.clientCreateAuthorityBasis = payload;
        },
        updateClientCreateLegalAddress(state, payload) {
            state.clientCreateLegalAddress = payload;
        },
        updateClientCreateCompanyPhone(state, payload) {
            state.clientCreateCompanyPhone = payload;
        },
        updateClientCreateTaxNumber(state, payload) {
            state.clientCreateTaxNumber = payload;
        },
        updateClientCreateBankAccount(state, payload) {
            state.clientCreateBankAccount = payload;
        },
        updateClientShowModal(state, payload) {
            state.clientShowModal = payload;
        },
        updateClientRequestIsLoading(state, payload) {
            state.clientRequestIsLoading = payload;
        },
        updateClientBirthday(state, payload) {
            state.clientCreateBirthday = payload;
        },
        updateClientPassportIssueDate(state, payload) {
            state.clientCreatePassportIssueDate = payload;
        },
        updatePassportIssuingAuthorityId(state, payload) {
            state.clientCreatePassportIssuingAuthorityId = payload;
        },
        updateClientPassportScan(state, payload) {
            state.clientCreatePassportScan = payload;
        },
        updateClientInvoiceDate(state, payload) {
            state.clientCreateInvoiceDate = payload;
        },
        clearCreateClient(state) {
            state.clientCreateFullName = null;
            state.clientCreateBirthday = null;
            state.clientCreateLegalData = false;

            state.clientCreateFirstPhone = null;
            state.clientCreateSecondPhone = null;
            state.clientCreateAddress = null;
            state.clientCreateEmail = null;
            state.clientCreatePassport = null;
            state.clientCreatePassportScan = null;
            state.clientCreatePassportIssueDate = null;
            state.clientCreatePassportIssuingAuthorityId = null;
            state.clientCreateRegistrationAddress = null;
            state.clientCreateWorkInfo = null;

            state.clientCreateCompanyName = null;
            state.clientCreateAuthorizedPerson = null;
            state.clientCreateAuthorityBasis = null;
            state.clientCreateLegalAddress = null;
            state.clientCreateCompanyPhone = null;
            state.clientCreateTaxNumber = null;
            state.clientCreateBankAccount = null;
            state.clientCreateInvoiceDate = null;
            state.clientsTotalSteps = 2;
            state.clientIsEditable = false;
            state.clientId = null;
            state.clientCreateBic = null;
            state.passportFilterAuthor = null;
            // state.clientFilterStr = null;

        },
        setEditClientData(state, data) {
            state.clientCreateFullName = data.fullName;

            if (data.birthdate != null) {
                state.clientCreateBirthday = data.birthdate.split('T')[0];
            }
            state.clientCreateLegalData = data.isLegalEntity;

            state.clientCreateFirstPhone = data.personalData.phone;
            state.clientCreateSecondPhone = data.personalData.additionalPhone;
            state.clientCreateAddress = data.personalData.address;
            state.clientCreateEmail = data.personalData.email;
            state.clientCreatePassport = data.personalData.passportNumber;
            state.clientCreatePassportScan = data.personalData.passportScan;
            if (data.personalData.passportIssueDate != null) {
                state.clientCreatePassportIssueDate = data.personalData.passportIssueDate.split('T')[0];
            }
            state.clientCreatePassportIssuingAuthorityId = data.personalData.passportIssuingAuthorityId;
            if (data.personalData.passportIssuingAuthorityId != null) {
                for (let i = 0; i < state.passportAuthors.length; i++) {
                    if (state.passportAuthors[i].id == data.personalData.passportIssuingAuthorityId) {
                        state.passportFilterAuthor = state.passportAuthors[i].name;
                    }
                }
            }
            state.clientCreateRegistrationAddress = data.personalData.registrationAddress;
            state.clientCreateWorkInfo = data.personalData.workInfo;
            state.clientId = data.personalData.clientId;
            state.personaDataId = data.personalData.id;

            if (data.isLegalEntity) {
                if (data.legalData !== null) {
                    state.clientCreateCompanyName = data.legalData.companyName;
                    state.clientCreateAuthorizedPerson = data.legalData.authorizedPerson;
                    state.clientCreateAuthorityBasis = data.legalData.authorityBasis;
                    state.clientCreateLegalAddress = data.legalData.legalAddress;
                    state.clientCreateCompanyPhone = data.legalData.companyPhone;
                    state.clientCreateTaxNumber = data.legalData.unpOrItn;
                    state.clientCreateBankAccount = data.legalData.bankAccount;
                    if (data.legalData.invoiceDate != null) {
                        state.clientCreateInvoiceDate = data.legalData.invoiceDate.split('T')[0];
                    }
                    state.legalDataId = data.legalData.id;
                    state.clientCreateBic = data.legalData.bankBIC;
                }
                state.clientsTotalSteps = 3;
            }
        },

        setUpdateOrderData(state, data) {
            state.createOrderStatus = data.status;
            state.createOrderClient = data.clientId;
            state.createOrderItems = data.orderItems;
            state.updateOrderId = data.id;
            state.createOrderTo = data.rentEndDate.split('T')[0];
            state.createOrderFrom = data.rentStartDate.split('T')[0];
            state.createOrderDiscount = data.discount;
            state.orderDeposit = data.securityDepositAmount;
            state.orderInstallation = data.ustanovka;
            state.orderAssembly = data.sborka;
            state.orderShipment = data.delivery;
            state.orderPaidFor = data.oplacheno;
        },

        updateClientPersonalData(state, payload) {
            state.clientPersonalData = payload;
        },

        updateClientShowData(state, payload) {
            state.clientShowData = payload;
        },

        updateClientLoadData(state, payload) {
            state.clientLoadData = payload;
        },
        updateCurrentClientName(state, payload) {
            state.currentClientName = payload;
        },

        updateClientLegalData(state, payload) {
            state.clientLegalData = payload;
        },
        updateClientLegalShowData(state, payload) {
            state.clientLegalShowData = payload;
        },
        updateClientLegalLoadData(state, payload) {
            state.clientLegalLoadData = payload;
        },
        updateClientId(state, payload) {
            state.clientId = payload;
        },
        updateClientIsEditable(state, payload) {
            state.clientIsEditable = payload;
        },
        updateOrderEditable(state, payload) {
            state.orderEditable = payload;
        },
        updatePersonaDataId(state, payload) {
            state.personaDataId = payload;
        },
        updateLegalDataId(state, payload) {
            state.legalDataId = payload;
        },
        updateProductCreateName(state, payload) {
            state.productCreateName = payload;
        },
        updateProductCreateDescription(state, payload) {
            state.productCreateDescription = payload;
        },
        updateProductCreateComplectation(state, payload) {
            state.productCreateComplectation = payload;
        },
        updateProductCreateEquipmentCost(state, payload) {
            state.productCreateEquipmentCost = payload;
        },
        updateProductCreateRentCost(state, payload) {
            state.productCreateRentCost = payload;
        },
        updateProductCreateSerialNumber(state, payload) {
            state.productCreateSerialNumber = payload;
        },
        updateProductCreateQty(state, payload) {
            state.productCreateQty = payload;
        },
        clearProductCreate(state) {
            state.productCreateName = null;
            state.productCreateDescription = null;
            state.productCreateComplectation = null;
            state.productCreateEquipmentCost = null;
            state.productCreateRentCost = null;
            state.productCreateSerialNumber = null;
            state.productCreateQty = null;
            state.productId = null;
        },
        clearSingleCreateProduct(state) {
            state.createOrderProduct = null;
            state.createOderSingleProductPrice = null;
            state.createOrderProductCount = null;
            state.createOrderSelectedCount = null;
            state.createSingleOrderTotalPrice = 0;

        },
        clearOrderData(state) {
            state.createOrderStatus = 2;
            state.createOrderClient = null;
            state.createOrderProduct = null;
            state.createOderSingleProductPrice = null;
            state.createOrderProductCount = null;
            state.createOrderSelectedCount = null;
            state.createSingleOrderTotalPrice = 0;
            state.createOrderFrom = null;
            state.createOrderTo = null;
            state.createOrderDiscount = 0;
            state.createOrderDayDifference = 0;
            state.createOrderPromo = 0;
            state.createOrderItems = [];
            state.updateOrderId = null;
            state.orderDeposit = 0;
            state.orderEditable = false;
            state.orderAssembly = 0;
            state.orderShipment = 0;
            state.orderInstallation = 0;
            state.orderPaidFor = 0;
        },
        updateProductIsLoading(state, payload) {
            state.isProductLoading = payload;
        },

        updateBlackListIsLoading(state, payload) {
            state.isBlackListLoading = payload;
        },
        updateRepairIsLoading(state, payload) {
            state.isRepairLoading = payload;
        },

        setProductEditData(state, product) {
            state.productCreateName = product.name;
            state.productCreateDescription = product.description;
            state.productCreateComplectation = product.complectation;
            state.productCreateEquipmentCost = product.equipmentCost;
            state.productCreateRentCost = product.rentCost;
            state.productCreateSerialNumber = product.serialNumber;
            state.productCreateQty = product.qty;
            state.productId = product.id;
        },
        updateClientSearchText(state, payload) {
            state.clientSearchText = payload;
        },
        updateProductSearchText(state, payload) {
            state.productSearchText = payload;
        },
        updateBlackListSearchText(state, payload) {
            state.blackListSearchText = payload;
        },
        updateClientPaginationStart(state, paginationStart) {
            state.clientPaginationStart = paginationStart;
        },
        updateProductPaginationStart(state, paginationStart) {
            state.productPaginationStart = paginationStart;
        },
        updateBlackListPaginationStart(state, paginationStart) {
            state.blackListPaginationStart = paginationStart;
        },
        updateRepairPaginationStart(state, paginationStart) {
            state.repairPaginationStart = paginationStart;
        },
        updateOrderModal(state, payload) {
            state.orderModal = payload;
        },

        updateOrderDataIsLoading(state, payload) {
            state.orderDataIsLoading = payload;
        },
        updateOrderStatus(state, payload) {
            state.createOrderStatus = payload;
        },
        updateCreateOrderClient(state, payload) {
            state.createOrderClient = payload;
        },
        updateCreateOrderProduct(state, payload) {
            state.createOrderProduct = payload;
        },
        updateSingleProductPrice(state, payload) {
            state.createOderSingleProductPrice = payload;
        },
        updateSingleProductQty(state, payload) {
            state.createOrderProductCount = payload;
        },
        updateSelectedProductCount(state, payload) {
            state.createOrderSelectedCount = payload;
        },
        updateOrderSingleTotalPrice(state, payload) {
            state.createSingleOrderTotalPrice = payload;
        },
        updateCreateOrderFrom(state, payload) {
            state.createOrderFrom = payload;
        },
        updateCreateOrderTo(state, payload) {
            state.createOrderTo = payload;
        },
        updateCreateOrderDiscount(state, payload) {
            state.createOrderDiscount = payload;
        },
        updateDayDifference(state, payload) {
            state.createOrderDayDifference = payload;
        },
        updateCreateProductItems(state, payload) {
            state.createProductItems = payload;
        },
        updateCreateOrderPromo(state, payload) {
            state.createOrderPromo = payload;
        },
        updateIsOrderDataLoading(state, payload) {
            state.isOrderDataLoading = payload;
        },
        updateOrderViewModal(state, payload) {
            state.orderProductsModal = payload;
        },
        updateOrderViewDataIsLoading(state, payload) {
            state.orderViewProductsIsLoading = payload;
        },
        updateOrderViewProducts(state, payload) {
            state.orderProductsView = payload;
        },
        updateOrderId(state, payload) {
            state.updateOrderId = payload;
        },
        updateOrderDeposit(state, payload) {
            state.orderDeposit = payload;
        },
        updateOrderPaginationStart(state, payload) {
            state.orderPaginationStart = payload;
        },
        updateFilterOrderByStatusId(state, payload) {
            state.filterOrderByStatusId = payload;
        },
        updateFilterOrderByDate(state, payload) {
            state.filterOrderByDate = payload;
        },
        updateFilterOrderByDateStart(state, payload) {
            state.filterOrderByDateStart = payload;
        },
        updateArendaOrderStart(state, payload) {
            state.arendaOrderStart = payload;
        },
        updateArendaOrderEnd(state, payload) {
            state.arendaOrderEnd = payload;
        },
        updateOrderProductModal(state, payload) {
            state.orderProductModal = payload;
        },

        updateCountControllers(state, payload) {
            state.countControllers = payload;
        },
        updateAvailableCountProducts(state, payload) {
            state.availableCountProducts = payload;
        },
        updateClientCreateBankBic(state, payload) {
            state.clientCreateBic = payload;
        },
        updateClientSortType(state, payload) {
            state.clientSortType = payload;
        },
        updateProductSortType(state, payload) {
            state.productSortType = payload;
        },
        updateBlackListSortType(state, payload) {
            state.blackListSortType = payload;
        },
        updateOrderShipment(state, payload) {
            state.orderShipment = payload;
        },
        updateOrderAssembly(state, payload) {
            state.orderAssembly = payload;
        },
        updateOrderInstallation(state, payload) {
            state.orderInstallation = payload;
        },
        updateOrderPaidFor(state, payload) {
            state.orderPaidFor = payload;
        },
        updateClientFilterStr(state, payload) {
            state.clientFilterStr = payload;
        },
        updatePassportFilterAuthor(state, payload) {
            state.passportFilterAuthor = payload;
        },
        updateCreateRepairProductFilter(state, payload) {
            state.createRepairProductFilter = payload;
        },
        updateIsDocLoading(state, payload) {
            state.isDocLoading = payload;
        },
        updatePassportModal(state, payload) {
            state.createPassportModal = payload;
        },
        updateCreatePassportName(state, payload) {
            state.passportCreateName = payload;
        },
        updatePassportAuthors(state, payload) {
            state.passportAuthors = payload;
        },
        updateClientOrders(state, payload) {
            state.clientOrders = payload;
        },
        updateClientsOrdersModal(state, payload){
            state.clientsOrdersModal = payload;
        },
        updateClientOrderStatisticItem(state, payload){
            state.clientOrderStatisticItem = payload;
        },
        updateProductAdditionalInfoModal(state, payload){
            state.productAdditionalInfoModal = payload;
        },
        updateProductAdditionalInfo(state, payload){
            state.productAdditionalInfo = payload;
        },
        updateAddProductSearchStr(state, payload){
            state.addProductSearchStr = payload;
        },
        updateSearchOrderName(state, payload){
            state.searchOrderName = payload;
        },
        updateProductsInSale(state, payload){
            state.productsInSales = payload;
        },
        updateClientNameInOrder(state, payload){
            state.clientNameInOrder = payload;
        },
        updateClientPhoneInOrder(state, payload){
            state.clientPhoneInOrder = payload;
        },
        updateCreateRepairProductId(state, payload){
            state.createRepairProductId = payload;
        },
        updateCreateRepairReason(state, payload){
            state.createRepairReason = payload;
        },
        updateRepairProducts(state, payload){
            state.repairProducts = payload;
        },
        updateSezon(state, payload){
            state.sezon = payload;
        },
        clearRepairProducts(state){
            state.createRepairProductFilter = null;
            state.createRepairProductId = null;
            state.createRepairReason = null;
        }
    },
    actions: {
        toggleSidebarColor({commit}, payload) {
            commit("sidebarType", payload);
        },
        setClientFullName({commit}, payload) {
            commit('updateClientCreateFullName', payload);
        },
        setClientLegalData({commit}, payload) {
            commit('updateClientCreateLegalData', payload);
        }
    },
    getters: {}
});
